













import Vue from 'vue'
import Component from 'vue-class-component'
import { AgeGroup, ProductAvailability, ProductCondition } from '@/modules/seo/types';

@Component
export default class ProductEditor extends Vue {

    /**
     * Grupos de edad
     */
    get ageGroups (): object[] {
        return [
            { value: AgeGroup.Kids, text: 'Para niños'},
            { value: AgeGroup.Adults, text: 'Adultos'},
            { value: AgeGroup.AllAges, text: 'Todas las edades'},
            { value: AgeGroup.Newborn, text: 'Recien nacido'},
            { value: AgeGroup.Teen, text: 'Adolescentes'},
        ]
    }

    get availability () {
        return [
            { value: ProductAvailability.InStock, text: 'En stock'},
            { value: ProductAvailability.Pending, text: 'Pendiente'},
            { value: ProductAvailability.OutOfStock, text: 'Fuera de existencias'},
            { value: ProductAvailability.AvailableForOrder, text: 'Disponible para pedir'},
        ]
    }

    get condition () {
        return [
            { value: ProductCondition.New, text: 'Nuevo' },
            { value: ProductCondition.Used, text: 'Usado' },
            { value: ProductCondition.Refurbished, text: 'Restaurado' },
        ]
    }
}
